import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditEmailTemplate = lazy(() =>
  import("@scenes/MessageComposition/Email/EmailTemplates/EmailTemplateLibrary/EditEmailTemplate").then(
    (module) => ({
      default: module.EditEmailTemplate,
    })
  )
);

export const engagementTemplatesAndMediaEmailTemplatesIdNRO: NavigationRoutingObject = {
  Component: EditEmailTemplate,
  componentFeatureFlippers: ["email_templates_nro_component"],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-email-templates-id-nro-heading", "Edit Email Template"),
  icon: "nav-system-email-templates",
  getDeveloperNavigationAllowed: ({ hasPermissionForAnyScope, featureOn, hasPermission }) => {
    const isGranularPermissionsEnabled =
      featureOn("clip_granular_permissions_all") && featureOn("clip_granular_permission_basic_read_only");
    if (isGranularPermissionsEnabled) {
      return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewEmailTemplates" });
    }
    return hasPermissionForAnyScope("basicReadOnly");
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
